module.exports = __webpack_public_path__ + "img/footer-sph.92b9967c.jpg";